import { createStyles } from '@material-ui/core/styles';

export const AllMetricsStyles = theme =>
  createStyles({
    AllMetrics_paper: {
      maxWidth: 1230,
      marginBottom: theme.spacing(3),
      paddingTop: 0,
      margin: 'auto',
      borderRadius: '25px',
      boxShadow: '0px 7px 40px -12px rgba(0,0,0,0.2)'
    }
  });
